import { FieldProps } from "../Field";
import { Alert as MuiAlert } from "@mui/material";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { ALERT_SEVERITY, ALERT_TEXT, AlertColors } from "@/core/types/types";

const Alert = ({ field }: FieldProps) => {
  const { properties } = field;
  const alertSeverity: AlertColors = String(
    properties[ALERT_SEVERITY]
  ) as AlertColors;
  const alertText: string = t(String(properties[ALERT_TEXT]));
  return <MuiAlert severity={alertSeverity}>{alertText}</MuiAlert>;
};

export default Alert;
